import { Component, type ReactNode } from "react";
import i18n from "../i18n";

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

/**
 * Last-resort guard: a render/lifecycle exception anywhere below swaps in a
 * friendly reload screen instead of a blank page. Uses i18n.t directly —
 * class components can't use hooks, and the boundary must render even if the
 * react-i18next provider itself is what threw.
 */
export default class ErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: unknown, info: unknown): void {
    console.error("ErrorBoundary caught", error, info);
  }

  override render(): ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="tp-app">
        <div className="tp-screen" style={{ paddingTop: 80, textAlign: "center" }}>
          <div className="tp-display" style={{ marginBottom: 12 }}>{i18n.t("errors.boundaryTitle")}</div>
          <div className="tp-body" style={{ color: "var(--tp-ink-soft)", marginBottom: 24 }}>
            {i18n.t("errors.boundaryBody")}
          </div>
          <button
            className="tp-btn tp-btn-primary tp-btn-block"
            style={{ maxWidth: 320, margin: "0 auto" }}
            onClick={() => window.location.reload()}
          >
            {i18n.t("errors.reload")}
          </button>
        </div>
      </div>
    );
  }
}
